import { enqueueSnackbar } from 'notistack';

/** Drop-in replacement for prior sonner `toast` usage */
export const toast = {
  success: (message) => enqueueSnackbar(message, { variant: 'success' }),
  error: (message) => enqueueSnackbar(message, { variant: 'error' }),
};
